module.exports = __webpack_public_path__ + "static/media/setup_data.7e681a48.webp";